import {
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
  FaTelegram,
  FaEnvelope,
  FaStar,
  FaUserCircle,
  FaCog,
} from "react-icons/fa";

const canais = [
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: <FaWhatsapp />,
    activeClass: "bg-emerald-50 text-emerald-600 ring-emerald-100",
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: <FaInstagram />,
    activeClass: "bg-pink-50 text-pink-600 ring-pink-100",
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: <FaFacebook />,
    activeClass: "bg-blue-50 text-blue-600 ring-blue-100",
  },
  {
    key: "telegram",
    label: "Telegram",
    icon: <FaTelegram />,
    activeClass: "bg-sky-50 text-sky-600 ring-sky-100",
  },
  {
    key: "email",
    label: "Email",
    icon: <FaEnvelope />,
    activeClass: "bg-rose-50 text-rose-600 ring-rose-100",
  },
  {
    key: "favoritos",
    label: "Favoritos",
    icon: <FaStar />,
    activeClass: "bg-amber-50 text-amber-600 ring-amber-100",
  },
];

function Tooltip({ children, text }) {
  return (
    <div className="group relative flex items-center">
      {children}

      <span className="pointer-events-none absolute left-full top-1/2 z-50 ml-3 -translate-y-1/2 whitespace-nowrap rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 opacity-0 shadow-lg transition-all group-hover:translate-x-1 group-hover:opacity-100">
        {text}
      </span>
    </div>
  );
}

export default function Sidebar({
  canalSelecionado = "whatsapp",
  setCanalSelecionado,
}) {
  return (
    <aside className="flex h-full w-16 shrink-0 flex-col items-center justify-between border-r border-slate-200 bg-white px-2 py-4">
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-950 text-sm font-black tracking-tight text-white shadow-sm">
          CZ
        </div>

        <div className="h-px w-8 bg-slate-200" />
      </div>

      <nav className="flex flex-1 flex-col items-center justify-center gap-2">
        {canais.map((canal) => {
          const selected = canalSelecionado === canal.key;

          return (
            <Tooltip key={canal.key} text={canal.label}>
              <button
                type="button"
                onClick={() => setCanalSelecionado?.(canal.key)}
                aria-label={canal.label}
                className={`flex h-11 w-11 items-center justify-center rounded-2xl text-lg ring-1 transition ${
                  selected
                    ? `${canal.activeClass} shadow-sm`
                    : "bg-white text-slate-400 ring-transparent hover:bg-slate-100 hover:text-slate-700"
                }`}
              >
                {canal.icon}
              </button>
            </Tooltip>
          );
        })}
      </nav>

      <div className="flex flex-col items-center gap-2">
        <div className="h-px w-8 bg-slate-200" />

        <Tooltip text="Usuário">
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-100 text-slate-500 ring-1 ring-slate-200 transition hover:bg-slate-200 hover:text-slate-800"
            aria-label="Usuário"
          >
            <FaUserCircle size={22} />
          </button>
        </Tooltip>

        <Tooltip text="Configurações">
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white text-slate-400 ring-1 ring-slate-200 transition hover:bg-slate-100 hover:text-slate-700"
            aria-label="Configurações"
          >
            <FaCog size={17} />
          </button>
        </Tooltip>
      </div>
    </aside>
  );
}
